import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "pop-innerbox"
};
const _hoisted_2 = {
  class: "pop-main"
};
const _hoisted_3 = {
  key: 0,
  class: "title"
};
const _hoisted_4 = {
  key: 1,
  class: "title"
};
const _hoisted_5 = {
  key: 2,
  class: "view"
};
const _hoisted_6 = {
  class: "tools"
};
const _hoisted_7 = {
  class: "tabs"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "tab-content"
};
const _hoisted_10 = {
  key: 0,
  class: "innerbox",
  style: {
    "height": "100%"
  }
};
const _hoisted_11 = {
  class: "otherdesc"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 2
};
const _hoisted_15 = ["href"];
const _hoisted_16 = {
  class: "introduce-content"
};
const _hoisted_17 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = {
  key: 1,
  class: "innerbox",
  style: {
    "height": "100%"
  }
};
const _hoisted_21 = {
  class: "ullist"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "txtbox"
};
const _hoisted_26 = ["innerHTML"];
const _hoisted_27 = {
  key: 2,
  class: "innerbox",
  style: {
    "height": "100%"
  }
};
const _hoisted_28 = {
  class: "ullist"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "txtbox"
};
const _hoisted_33 = ["innerHTML"];
const _hoisted_34 = {
  key: 3,
  class: "innerbox",
  style: {
    "height": "100%"
  }
};
const _hoisted_35 = {
  class: "relatelist"
};
const _hoisted_36 = ["src"];
const _hoisted_37 = {
  key: 4,
  class: "innerbox",
  style: {
    "height": "100%"
  }
};
const _hoisted_38 = {
  class: "relatelist video"
};
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  class: "videoPlay"
};
const _hoisted_42 = ["src"];
const _hoisted_43 = {
  key: 5,
  class: "innerbox",
  style: {
    "height": "100%"
  }
};
const _hoisted_44 = {
  class: "relatelist1"
};
const _hoisted_45 = {
  class: "audiobox"
};
const _hoisted_46 = {
  class: "sharecode"
};
const _hoisted_47 = {
  class: "qrcode-share",
  ref: "qrcode-share"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_View = _resolveComponent("View");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_vue_audio = _resolveComponent("vue-audio");
  const _component_Close = _resolveComponent("Close");
  return _openBlock(), _createElementBlock("div", null, [$props.popshowflag && $props.detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["popcontainer-style3", [{
      'mobile': $props.isMobile
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }, [...(_cache[7] || (_cache[7] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))]), _cache[16] || (_cache[16] = _createElementVNode("div", {
    class: "popinnerbg"
  }, null, -1)), _createElementVNode("div", _hoisted_2, [$data.popDetail.place_name !== undefined ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString($data.popDetail.place_name), 1)) : (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString($data.popDetail.title), 1)), $data.popDetail.views !== undefined ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_View)]),
    _: 1
  }), _createTextVNode(_toDisplayString($data.popDetail.views) + "次浏览", 1)])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_6, [$data.popDetail.detailUrl !== undefined && $data.popDetail.detailUrl !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    class: "li1",
    onClick: _cache[1] || (_cache[1] = $event => $options.getCode($data.popDetail.detailUrl))
  }, [...(_cache[8] || (_cache[8] = [_createElementVNode("span", null, [_createElementVNode("i")], -1), _createElementVNode("p", null, "分享", -1)]))])) : _createCommentVNode("", true), $data.popDetail.correlation_address !== undefined && $data.popDetail.correlation_address.length > 0 && $data.popDetail.correlation_address[0].address ? (_openBlock(), _createElementBlock("li", {
    key: 1,
    class: "li2",
    onClick: _cache[2] || (_cache[2] = $event => $options.goLocation($props.detail))
  }, [...(_cache[9] || (_cache[9] = [_createElementVNode("span", null, [_createElementVNode("i")], -1), _createElementVNode("p", null, "导航", -1)]))])) : _createCommentVNode("", true), $data.popDetail.route !== undefined && $data.popDetail.route.length > 0 && $data.popDetail.route[0].address !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 2,
    class: "li2",
    onClick: _cache[3] || (_cache[3] = $event => $options.goLocation($props.detail))
  }, [...(_cache[10] || (_cache[10] = [_createElementVNode("span", null, [_createElementVNode("i")], -1), _createElementVNode("p", null, "导航", -1)]))])) : _createCommentVNode("", true), $data.popDetail.detailUrl !== undefined && $data.popDetail.detailUrl !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 3,
    class: "li3",
    onClick: _cache[4] || (_cache[4] = $event => $options.godetail($data.popDetail.detailUrl))
  }, [...(_cache[11] || (_cache[11] = [_createElementVNode("span", null, [_createElementVNode("i")], -1), _createElementVNode("p", null, "详情", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popDetail.labelGroup, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: item
    }, [item.flag ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["tab-item", {
        'active': $data.tabIndex === index
      }]),
      onClick: $event => $options.tabClick(item, index)
    }, _toDisplayString(item.label), 11, _hoisted_8)) : _createCommentVNode("", true)], 64);
  }), 128))]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popDetail.labelGroup, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: item
    }, [item.id === 0 && $data.tabIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$data.popDetail.correlation_address !== undefined && $data.popDetail.correlation_address.length > 0 && $data.popDetail.correlation_address[0].address ? (_openBlock(), _createElementBlock("p", _hoisted_12, [_cache[12] || (_cache[12] = _createElementVNode("span", {
      class: "icon-location1"
    }, null, -1)), _createTextVNode(" " + _toDisplayString($data.popDetail.correlation_address[0].address), 1)])) : _createCommentVNode("", true), $data.popDetail.route !== undefined && $data.popDetail.route.length > 0 && $data.popDetail.route[0].address !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_13, [_cache[13] || (_cache[13] = _createElementVNode("span", {
      class: "icon-location1"
    }, null, -1)), _createTextVNode(" " + _toDisplayString($data.popDetail.route[0].address), 1)])) : _createCommentVNode("", true), $data.popDetail.telphone !== undefined && $data.popDetail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_14, [_createElementVNode("a", {
      href: `tel:${$data.popDetail.telphone}`
    }, [_cache[14] || (_cache[14] = _createElementVNode("span", {
      class: "icon-tel"
    }, null, -1)), _createTextVNode(" " + _toDisplayString($data.popDetail.telphone), 1)], 8, _hoisted_15)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [$data.introimg !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("img", {
      src: $data.introimg,
      alt: ""
    }, null, 8, _hoisted_18)])) : _createCommentVNode("", true), $data.introDesc !== '' ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "txtbox",
      innerHTML: $data.introDesc
    }, null, 8, _hoisted_19)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), item.id === 1 && $data.tabIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("ul", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mapculturalprojectList, item => {
      return _openBlock(), _createElementBlock("li", {
        key: item,
        onClick: $event => _ctx.goDetail(item.detailUrl)
      }, [item.itemformdata.thumb.length ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("img", {
        src: $options.getImg(item.itemformdata.thumb[0]),
        alt: ""
      }, null, 8, _hoisted_24)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [_createElementVNode("h3", null, _toDisplayString(item.itemformdata.title), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, "级别：" + _toDisplayString(item.itemformdata.level), 1), _createElementVNode("li", null, "批次：" + _toDisplayString(item.itemformdata.batch), 1), _createElementVNode("li", null, "分类：" + _toDisplayString(item.itemformdata.category), 1), _createElementVNode("li", null, "类型：" + _toDisplayString(item.itemformdata.type), 1)])]), item.itemformdata[112] ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "descbox",
        innerHTML: item.itemformdata[112]
      }, null, 8, _hoisted_26)) : _createCommentVNode("", true)], 8, _hoisted_22);
    }), 128)), $data.mapculturalprojectList.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
      key: 0,
      description: "暂无数据"
    })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), item.id === 2 && $data.tabIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("ul", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.mapculturalpersonList, item => {
      return _openBlock(), _createElementBlock("li", {
        key: item,
        onClick: $event => _ctx.goDetail(item.detailUrl)
      }, [item.itemformdata.thumb.length ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("img", {
        src: $options.getImg(item.itemformdata.thumb[0]),
        alt: ""
      }, null, 8, _hoisted_31)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [_createElementVNode("h3", null, _toDisplayString(item.itemformdata.name), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, "性别：" + _toDisplayString(item.itemformdata.sex), 1), _createElementVNode("li", null, "出生日期：" + _toDisplayString(item.itemformdata.birthday), 1), _createElementVNode("li", null, "民族：" + _toDisplayString(item.itemformdata.nation), 1), _createElementVNode("li", null, "类别：" + _toDisplayString(item.itemformdata.category), 1)])]), item.itemformdata.introduce ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "descbox",
        innerHTML: item.itemformdata.introduce
      }, null, 8, _hoisted_33)) : _createCommentVNode("", true)], 8, _hoisted_29);
    }), 128)), $data.mapculturalpersonList.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
      key: 0,
      description: "暂无数据"
    })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), item.id === 3 && $data.tabIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("ul", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.relatePic, item => {
      return _openBlock(), _createElementBlock("li", {
        key: item
      }, [_createElementVNode("img", {
        src: item.fileUrl,
        alt: ""
      }, null, 8, _hoisted_36)]);
    }), 128)), $data.relatePic.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
      key: 0,
      description: "暂无数据"
    })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), item.id === 4 && $data.tabIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_withDirectives(_createElementVNode("ul", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.relateVideo, item => {
      return _openBlock(), _createElementBlock("li", {
        key: item,
        onClick: $event => $options.videoItemHandle(item)
      }, [_createElementVNode("img", {
        src: item.fileUrl,
        alt: ""
      }, null, 8, _hoisted_40)], 8, _hoisted_39);
    }), 128)), $data.relateVideo.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
      key: 0,
      description: "暂无数据"
    })) : _createCommentVNode("", true)], 512), [[_vShow, !$data.videoitemflag]]), _withDirectives(_createElementVNode("div", _hoisted_41, [_createElementVNode("div", {
      class: "closediv",
      onClick: _cache[5] || (_cache[5] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
    }, [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
      class: "icon-close"
    }, null, -1)]))]), _createElementVNode("video", {
      src: $data.videoUrl,
      controls: ""
    }, null, 8, _hoisted_42)], 512), [[_vShow, $data.videoitemflag]])])) : _createCommentVNode("", true), item.id === 5 && $data.tabIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("ul", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.relateAudio, item => {
      return _openBlock(), _createElementBlock("li", {
        key: item
      }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_45, [_createVNode(_component_vue_audio, {
        file: item.url
      }, null, 8, ["file"])])]);
    }), 128)), $data.relateAudio.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
      key: 0,
      description: "暂无数据"
    })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 64);
  }), 128))])]), _withDirectives(_createElementVNode("div", _hoisted_46, [_createElementVNode("div", {
    class: "codetop",
    onClick: _cache[6] || (_cache[6] = $event => $data.ewmflag = false)
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Close)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_47, null, 512)], 512), [[_vShow, $data.ewmflag]])])], 2)) : _createCommentVNode("", true)]);
}